import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-bar-wrap" }

import { useAuth0 } from '@auth0/auth0-vue';
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import CustomMenubar from './CustomMenubar.vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  name: 'NavBar',
  setup(__props) {

const store = useStore();
const auth0 = useAuth0();
const router = useRouter();
const isAuthenticated = ref(auth0.isAuthenticated);
const isLoading = ref(auth0.isLoading);
const user = ref(auth0.user);
const userRole = computed(() => {
  if (!user.value) return null
  return user.value['http://protractor.com/role'] || null
});

const homeLabel = computed(() => {
  return userRole.value === 'EnterpriseAdmin' ? 'Store Home' : 'Home'
});

/**
 * List of tabs for VINScanner
 */
const vinscannerTabs = ref([
  {
    label: homeLabel,
    path: '/'
  },
  {
    label: 'Work Orders',
    path: '/workorders'
  }
]);

/**
 * List of tabs for DVI
 */
const DVITabs = ref([
  {
    label: homeLabel,
    path: '/'
  },
  {
    label: 'Work Orders',
    path: '/dviworkorders'
  },
]);

const ReportingTabs = ref([
  {
    label: homeLabel,
    path: '/'
  },
  {
    label: 'Dashboard',
    path: '/reporting'
  },
  {
    label: 'Reports',
    path: '/reports'
  }
]);

const EnterpriseReportTabs = ref([
  {
    label: 'Enterprise Home',
    path: '/'
  }
]);

const dvipages = ['/dviworkorders', '/dviworkorderpackages', '/dviupdateworkorderpackage', '/dvisummaryworkorderpackage'];
const vinscannerpages = ['/workorders', '/updateorder'];
const reportingpages = ['/reporting', '/reports', '/reports2'];
const enterprisereportpages = ['/enterprise'];

const isHomePage = computed(() => router.currentRoute.value.path === '/');
const isVINScannerPage = computed(() => vinscannerpages.includes(router.currentRoute.value.path));
const isDVIPage = computed(() => dvipages.includes(router.currentRoute.value.path));
const isReportingPage = computed(() => reportingpages.includes(router.currentRoute.value.path));
const isEnterpriseReportPage = computed(() => enterprisereportpages.includes(router.currentRoute.value.path));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(isAuthenticated.value ? 'topbar auth' : 'topbar')
    }, [
      (!isAuthenticated.value && !isLoading.value)
        ? (_openBlock(), _createBlock(CustomMenubar, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(isHomePage) && isAuthenticated.value && _unref(userRole) !== 'EnterpriseAdmin')
        ? (_openBlock(), _createBlock(CustomMenubar, {
            key: 1,
            user: user.value
          }, null, 8, ["user"]))
        : _createCommentVNode("", true),
      (_unref(isVINScannerPage) && isAuthenticated.value)
        ? (_openBlock(), _createBlock(CustomMenubar, {
            key: 2,
            model: vinscannerTabs.value,
            user: user.value
          }, null, 8, ["model", "user"]))
        : _createCommentVNode("", true),
      (_unref(isDVIPage) && isAuthenticated.value)
        ? (_openBlock(), _createBlock(CustomMenubar, {
            key: 3,
            model: DVITabs.value,
            user: user.value
          }, null, 8, ["model", "user"]))
        : _createCommentVNode("", true),
      (_unref(isReportingPage) && isAuthenticated.value)
        ? (_openBlock(), _createBlock(CustomMenubar, {
            key: 4,
            model: ReportingTabs.value,
            user: user.value
          }, null, 8, ["model", "user"]))
        : _createCommentVNode("", true),
      (_unref(isEnterpriseReportPage) && isAuthenticated.value)
        ? (_openBlock(), _createBlock(CustomMenubar, {
            key: 5,
            model: EnterpriseReportTabs.value,
            user: user.value
          }, null, 8, ["model", "user"]))
        : _createCommentVNode("", true),
      (_unref(isHomePage) && isAuthenticated.value && _unref(userRole) === 'EnterpriseAdmin' && !_unref(store).state.isStoreLogin)
        ? (_openBlock(), _createBlock(CustomMenubar, {
            key: 6,
            user: user.value
          }, null, 8, ["user"]))
        : _createCommentVNode("", true),
      (_unref(isHomePage) && isAuthenticated.value && _unref(userRole) === 'EnterpriseAdmin' && _unref(store).state.isStoreLogin)
        ? (_openBlock(), _createBlock(CustomMenubar, {
            key: 7,
            model: EnterpriseReportTabs.value,
            user: user.value
          }, null, 8, ["model", "user"]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})